import { get, orderBy } from 'lodash';
import { createSelector } from 'reselect';
import { policiesSelector } from '../precisionPolicy/selectors';
import SCOPE from './types';

const selector = (state) => get(state, SCOPE);

export const baseSelector = createSelector(selector, (state) => state.base);
export const formViewSelector = createSelector(selector, (state) => state.form);
export const listViewSelector = createSelector(selector, (state) => state.list);

export const activeTabSelector = createSelector(baseSelector, (state) => state.activeTab);

export const policyOptionsSelector = createSelector(
  policiesSelector,
  formViewSelector,
  (policies, { policies: selectedPolicies }) => {
    const options: any = [];

    // order by policy index order for multiselect
    const orderedPolicies = orderBy(policies, ['index'], ['asc']);

    orderedPolicies.forEach((p) => {
      const versions: any = [];
      let isFilterSelected = false;

      p.versions.forEach((v) => {
        const selected = selectedPolicies.includes(v.id);
        versions.push({
          id: v.id,
          title: v.name,
          filterId: p.id,
          selected,
          active: v.is_active,
        });
        isFilterSelected = isFilterSelected || selected;
      });
      options.push({ id: p.id, title: p.filter_name, versions, selected: isFilterSelected });
    });

    return options;
  },
);

export const policyLookupSelector = createSelector(policiesSelector, (policies) => {
  const lookup = {};
  policies.forEach((policy) => {
    policy.versions.forEach((version) => {
      lookup[version.id] = version;
    });
  });
  return lookup;
});

export default selector;
